export const inbound_form = {
  data() {
    return {
      sum: 0,
      rules: {
        customer_id: [{ required: true, message: "거래처를 선택해 주세요." }],
        inbound_date: [{ required: true, message: "매입일을 선택해 주세요." }],
      }
    };
  },
  computed: {
    isNew: function() {
      return this.data.id < 1;
    },
    invalid_details() {
      let invalid_index = [];
      this.getDetails().forEach((d, index) => {
        if (d.product_name && !d.product_id) {
          return invalid_index.push(index+1);
        }
      });
      return invalid_index;
    },
  },
  methods: {
    initData() {
      return {
        id: 0,
        code: "",
        customer_id: 0,
        inbound_date: this.util.getDate(0),
        charge_id: null,
        customer_charger: "",
        location: "",
        customer_name: "",
        status_flag: "N",
        tel: "",
        fax: "",
        price: 0,
        cost: 0,
        owner: "",
        details: []
      };
    },
    getDetails() {
      const trades = this.$refs.trade.result();
      const details = [];
      //let product_name = '';
      for (let i = 0; i < trades.length; i++) {
        if (!trades[i].product_id && !trades[i].amount) {
          continue;
        }
        if (!trades[i].cost) { trades[i].cost = null; }
        if (!trades[i].supply_price) { trades[i].supply_price = null; }
        if (!trades[i].tax) { trades[i].tax = null; }
        let detail = Object.assign({}, trades[i]);
        if (!detail.price) { detail.price = 0 }
        detail.seq = i + 1;        
        details.push(detail);
      }      
      return details;
    },  
    handleSelectCustomer(c) {
      if (typeof c === "string") {
        this.data.customer_id = null;
        this.data.customer_name = c;        
        this.customer = null;
      } else {
        this.data.customer_id = c.id;
        this.data.customer_name = c.name;        
        this.customer = c;
      }
    },
    handleChangedSum(sum) {
      this.sum = sum;
    },
    handleClickClear() {
      // this.$refs.trade.clear();
      this.data.id = 0;
      this.data.inbound_date = this.util.getDate(0);
      this.data.details = [];
    },
  }
}